import type { RouteRecordRaw } from 'vue-router'

import type { RouterConfig } from 'nuxt/schema'

import authRoutes from '~/scopes/auth/routes'
import buybackRoutes from '~/scopes/buyback/routes'
import customerCareRoutes from '~/scopes/customer-care/routes'
import customerReviewsRoutes from '~/scopes/customer-reviews/routes'
import feedbackRoutes from '~/scopes/feedback/routes'
import homeRoutes from '~/scopes/home/routes'
import insightsRoutes from '~/scopes/insights/routes'
import invoicesRoutes from '~/scopes/invoices/routes'
import legacyRoutes from '~/scopes/legacy/routes'
import listingsRoutes from '~/scopes/listings/routes'
import noAccessRoutes from '~/scopes/no-access/routes'
import opportunitiesRoutes from '~/scopes/opportunities/routes'
import optionsRoutes from '~/scopes/options/routes'
import ordersRoutes from '~/scopes/orders/routes'
import profileRoutes from '~/scopes/profile/routes'
import shippingRoutes from '~/scopes/shipping/routes'

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  routes: (fileSystemRoutes): readonly RouteRecordRaw[] => {
    return [
      ...authRoutes(),
      ...customerCareRoutes(),
      ...customerReviewsRoutes(),
      ...homeRoutes(),
      ...fileSystemRoutes,
      ...insightsRoutes(),
      ...invoicesRoutes(),
      ...legacyRoutes,
      ...noAccessRoutes,
      ...opportunitiesRoutes(),
      ...optionsRoutes(),
      ...profileRoutes(),
      ...listingsRoutes(),
      ...ordersRoutes(),
      ...shippingRoutes(),
      ...feedbackRoutes(),
      ...buybackRoutes(),
    ]
  },
}
